<div class="modal-header">
  <div class="modal-title normal-text center">{{ title | translate }}</div>
</div>
<div class="modal-body center">
  <div class="normal-text message">{{ message | translate }}:</div>
  <div class="normal-text time">{{ timeout | hourMinuteSecond }}</div>
</div>
<div class="modal-footer">
</div>
